import { markRaw } from 'vue';
import axios from 'axios';
import { gunzipSync } from 'fflate';
import protobuf from 'protobufjs';

const readInt64 = protobuf.Reader.prototype.int64;
protobuf.Reader.prototype.int64 = function int64AsString() {
  return readInt64.call(this).toString();
};

function maybeDecompressGzipBuffer(buffer) {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);

  if (bytes[0] !== 0x1F || bytes[1] !== 0x8B) {
    return bytes;
  }

  return gunzipSync(bytes);
}

async function fetchRoundBuffer(url, signal) {
  const response = await fetch(url, { signal });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.arrayBuffer();
}

async function fetchRoundSchema(signal) {
  const protoSchemaURL = new URL('/demo.proto', window.location.href).href;
  const { data: protoSchema } = await axios.get(protoSchemaURL, {
    responseType: 'text',
    signal,
  });

  return protoSchema;
}

export function fillDeltaFrames(round) {
  const previous = new Map();
  let lastBomb = null;
  const exploded = round.bombEvents?.find((event) => event.event === 'bomb_exploded')?.tick ?? Infinity;

  for (const frame of round.frames) {
    const players = [...(frame.t?.players ?? []), ...(frame.ct?.players ?? [])];

    for (const player of players) {
      if (!player.inventory.length && player.isAlive !== false) delete player.inventory;

      const state = previous.get(player.steamID) ?? {};
      Object.assign(player, Object.assign(state, player));
      previous.set(player.steamID, state);
    }

    if (frame.tick >= exploded) {
      delete frame.bomb;
    } else if (!frame.bomb) {
      const carrier = !frame.bombPlanted && players.find((player) => player.isAlive !== false && player.inventory?.some((item) => item.weaponName === 'C4'));
      if (carrier) frame.bomb = { x: carrier.x, y: carrier.y, z: carrier.z };
      else if (lastBomb) frame.bomb = lastBomb;
    }
    if (frame.bomb) lastBomb = frame.bomb;
  }

  return round;
}

export function decodeRoundData(protoSchema, buffer) {
  const Round = protobuf.parse(protoSchema).root.lookupType('Round');
  return fillDeltaFrames(Round.decode(maybeDecompressGzipBuffer(buffer)));
}

export async function decodeRoundDataFromUrl(url, signal) {
  const [buffer, protoSchema] = await Promise.all([
    fetchRoundBuffer(url, signal),
    fetchRoundSchema(signal),
  ]);

  return markRaw(decodeRoundData(protoSchema, buffer));
}

export async function loadRoundDataRefFromUrl(roundDataRef, url, signal) {
  const decodedRoundData = await decodeRoundDataFromUrl(url, signal);

  if (roundDataRef.value) {
    roundDataRef.value = null;
  }

  roundDataRef.value = decodedRoundData;
}
